import React, { Component } from 'react';
import { Field } from 'redux-form';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';
import { lists as Lists } from '../../../common/lists';

class LocationTypeDropdown extends Component {

  render() {
    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      intl
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType='location_type'
          type='location_type'
          component={ multiple ? renderSearchMultipleDropdown : renderSearchDropDown }
          onPostChange={onPostChange}
          isFix
          listOptions={Lists.LOCATION_TYPE(intl)}
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default injectIntl(connect(null, mapDispatchToProps)(LocationTypeDropdown));
